import React, { useState } from 'react';
import Card, { CardRow } from 'components/styleguide/card/Card';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import Textarea from 'components/styleguide/textarea/Textarea';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

interface AboutUsCardProps {
  description: string;
  url: string;
}

const AboutUsCard: React.FC<AboutUsCardProps> = ({
  description: initialDescription,
  url,
}) => {
  const [display, setDisplay] = useState({
    description: initialDescription || '',
  });

  const sheet = useEditableSheet({
    url,
    payloadKey: 'company',
    onSuccess: (data) => {
      setDisplay({
        description: data.description || '',
      });
    },
  });

  const handleEditClick = (action: string) => {
    if (action === 'edit') {
      sheet.open('Edit about us', {
        description: display.description,
      });
    } else if (action === 'add') {
      sheet.open('Add about us', {
        description: undefined,
      });
    }
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    sheet.handleFormChange(e.target.name, e.target.value);
  };

  const dataFilled = display.description;

  return (
    <>
      <Card
        title="About us"
        iconName="fileText"
        context="company"
        tag={dataFilled ? undefined : { variant: 'warning', icon: 'circleAlert', children: 'Missing' }}
        onAdd={() => handleEditClick("add")}
        onEdit={() => handleEditClick("edit")}
      >
        {dataFilled && (
          <CardRow context="company">
            <p className={styles.description}>{display.description}</p>
          </CardRow>
        )}
      </Card>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="company"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <div className={styles.form}>
            <Textarea
              label='Your company bio'
              name="description"
              placeholder="Share what makes your company unique"
              className={styles.questionTextarea}
              defaultValue={sheet.formData.description || ''}
              onChange={handleTextareaChange}
              rows={6}
              maxLength={2000}
              showCharacterCount
              error={sheet.getError('description')}
            />
          </div>
        </Sheet>
      )}
    </>
  );
};

export default AboutUsCard;
